// components/Cards/BlueCards.js
import React from 'react';
import InfoCard from './InfoCard'; // Reuse the same component
import {
  FaLaptopCode,
  FaMobileAlt,
  FaRocket,
  FaShieldAlt,
  FaCloud,
  FaBrain,
  
  FaCogs,
  FaNetworkWired,
  FaBullhorn,
} from 'react-icons/fa';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { SiGoogleanalytics } from 'react-icons/si';
import './BlueCards.css'

const blueFeatures = [
  {
     id: "software",
    icon: FaLaptopCode,
    title: 'Custom Software Development',
    description: (<>Empower your business with tailor-made software crafted to solve your unique challenges and unlock new growth opportunities. We build scalable, secure, and high-performance solutions that evolve with your needs.
    <ul>
        <li>Full-stack development (frontend & backend)</li>
         <li>API design & integration</li>
          <li>Legacy system modernization & migration</li>
           <li>SaaS platforms & enterprise applications</li>
            <li>Cloud-native development</li>
    </ul>
    </>),
  },
  {  id: "web-mobile",
    icon: FaMobileAlt,
    title: 'Web and Mobile App Development',
    description: (<>High-performance web and mobile applications built to deliver seamless user experiences across all devices. From MVPs to scalable platforms, we bring your digital product ideas to life.
    <ul>
        <li>Native iOS & Android app development</li>
        <li>Cross-platform apps with React Native & Flutter</li>
        <li>Progressive Web Apps (PWAs) for wider reach</li>
        <li>App performance optimization & maintenance</li>
        <li>App store deployment & support</li>
    </ul>
    </>),
  },
  {
    id: "erp-sap",
    icon: FaNetworkWired,
    title: 'ERP & SAP Services',
    description: (<>Simplify business operations with cloud-based ERP systems and SAP consulting. From GST-compliant SME solutions to enterprise-grade SAP implementations, we help streamline finance, operations, and reporting.
    <ul>
        <li>HTBi ERP implementation & customization</li>
        <li>SAP S/4HANA & Business One deployment</li>
        <li>Module support: FICO, MM, SD, HCM</li>
        <li>System integration & automation</li>
        <li>SAP BASIS support & upgrades</li>
    </ul>
    </>),
  },
  {
     id: "cloud-devops",
    icon: FaCloud,
    title: 'Cloud & DevOps Solutions',
    description: (<>Accelerate your cloud journey with scalable architecture, secure cloud environments, and DevOps practices that streamline development and operations.
    <ul>
        <li>Cloud migration & deployment (AWS, Azure, GCP)</li>
         <li>Infrastructure as Code (IaC) & automation</li>
          <li>CI/CD pipeline setup & monitoring</li>
           <li>Cloud governance & cost optimization</li>
            <li>Serverless & containerized applications</li>
    </ul>
    </>),
  },
   {
    id: "ai-analytics",
    icon: FaBrain,
    title: 'AI & Data Analytics',
    description: (<>Turn data into decisions with AI-driven automation, analytics, and predictive intelligence to power smarter business strategies.
    <ul>
        <li>Custom AI/ML model development</li>
         <li>Predictive & prescriptive analytics</li>
          <li>Natural Language Processing (NLP)</li>
           <li>Business intelligence dashboards</li>
            <li>Data integration & ETL pipelines</li>
    </ul>
    </>),
  },
   {
    id: "cybersecurity",
    icon: FaShieldAlt,
    title: 'Cybersecurity Services',
    description: (<>Protect your business from evolving cyber threats with proactive, comprehensive security measures and ensure compliance with industry standards.
    <ul>
        <li>Security risk assessments & audits</li>
        <li>Penetration testing & vulnerability scanning</li>
        <li>Incident response & threat monitoring</li>
        <li>ompliance consulting (GDPR, HIPAA, etc.)</li>
        <li>Network security & endpoint protection</li>
    </ul>
    </>),
  },
  {
    id: "marketing-seo",
    icon:  FaBullhorn,
    title: 'Digital Marketing & SEO',
    description: (<>Boost your brand visibility and lead generation with targeted digital marketing strategies, SEO, and content that converts.
    <ul>
        <li>SEO (on-page, off-page, technical)</li>
         <li>Google Ads & paid campaign management</li>
          <li>Social media strategy & execution</li>
           <li>Content marketing & copywriting</li>
            <li>Analytics tracking & reporting</li>
    </ul>
    </>),
  },
  {
    id: "consulting",
    icon: FaCogs,
    title: 'IT Consulting& Digital Transformation',
    description: (<>Partner with us for expert guidance to align your technology with business goals through expert consulting, digital transformation planning, and process automation.
    <ul>
        <li>Technology assessments & audits</li>
        <li>IT strategy & digital transformation planning</li>
        <li>Process optimization & workflow automation</li>
        <li>Tech stack selection & vendor management</li>
        <li>Change management & adoption support</li>
    </ul>
    </>),
  },
  {
    id: "ui-ux",
    icon: HiOutlineLightBulb,
    title: 'UI/UX & Product Design',
    description: (<>Deliver seamless digital experiences through modern UI/UX design focused on usability, accessibility, and business outcomes.
    <ul>
        <li>Wireframing & prototyping</li>
        <li>Web & mobile UI design</li>
        <li>User journey mapping</li>
        <li>Design systems & style guides</li>
        <li>UX research & usability testing</li>
    </ul>
    </>),
  },
];

const BlueCards = () => {
  return (
    <div className="card-grid1">
      {blueFeatures.map((item, index) => (
         <div id={item.id} key={index}>
        <InfoCard
          key={index}
          icon={item.icon}
          title={item.title}
          description={item.description}
           variant="blue"
           
        />
        </div>
      ))}
    </div>
  );
};

export default BlueCards;
